import { httpClient, HttpMethod } from './http-client';

export const createTag = (tag: any) => {
  return httpClient('/tags', HttpMethod.Post, tag);
};

export const getAllUserTags= (id: number): any => {
  return httpClient(`/tags/tagsByEntityType/${id}`, HttpMethod.Get, null);
};